import React, { useState, useEffect } from 'react';
import { User, Mail, Phone, Shield } from 'lucide-react';
import api from '../../api/axios';
import toast from 'react-hot-toast';
import Button from '../../components/common/Button';
import styles from './SuperadminProfile.module.css';

const SuperadminProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data } = await api.get('/users/profile');
        setProfile(data);
      } catch (error) {
        toast.error('Failed to load profile');
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  if (loading) return <div className={styles.loading}>Loading Profile...</div>;
  if (!profile) return null;

  return (
    <div className={styles.profileContainer}>
      <div className={styles.header}>
        <h2>My Profile</h2>
        <p>Manage your superadmin account details</p>
      </div>

      <div className={styles.profileCard}>
        <div className={styles.avatarSection}>
          <div className={styles.avatar}>
            {profile.fullName?.charAt(0).toUpperCase()}
          </div>
          <div className={styles.roleBadge}>
            <Shield size={14} /> Superadmin
          </div>
        </div>

        <div className={styles.infoSection}>
          <div className={styles.infoGroup}>
            <label><User size={16} /> Full Name</label>
            <p>{profile.fullName}</p>
          </div>
          
          <div className={styles.infoGroup}>
            <label><Mail size={16} /> Email Address</label>
            <p>{profile.email}</p>
          </div>

          <div className={styles.infoGroup}>
            <label><Phone size={16} /> Phone Number</label>
            <p>{profile.phone || 'Not provided'}</p>
          </div>
        </div>

        <div className={styles.actions}>
          <Button variant="outline" onClick={() => toast('Edit profile coming soon!')}>
            Edit Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuperadminProfile;
